module.exports = __webpack_public_path__ + "compricer-case-bg.fb59f034b831e6c5ca87.webp";